import BaseModel from '@/orm/models/BaseModel';

export default class QuotaPrice extends BaseModel {
  static entity = 'quota_prices';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      quotaType: this.string(null),
      value: this.attr(null),
      currency: this.string(null),
      currencyName: this.string(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get('accounting/quota_prices');
      },
    },
  }
}
